import { State, AgendaTrack, AgendaItem, Broadcast } from './types';

const mutations = {
  setBroadcasts(state: State, broadcasts: []) {
    state.broadcasts = broadcasts;
  },
  setAgendaItems(state: State, agendaItems: []) {
    state.agendaItems = agendaItems;
  },
  setAgendaTracks(state: State, agendaTracks: []) {
    state.agendaTracks = agendaTracks;
  },
  setErrorFetchingAgendaItems(state: State, errorFetchingAgendaItems: any) {
    state.errorFetchingAgendaItems = errorFetchingAgendaItems;
  },
  setErrorFetchingBroadcasts(state: State, errorFetchingBroadcasts: any) {
    state.errorFetchingBroadcasts = errorFetchingBroadcasts;
  },
  setSelectedTrack(state: State, selectedTrack: AgendaTrack) {
    state.selectedTrack = selectedTrack;
  },
  updatePartialBroadcast(state: State, { id, payload }: { id: string; payload: any }) {
    state.broadcasts = state.broadcasts.map(broadcast => {
      if (broadcast.id === id) {
        if ('simulive_test_run_end_time' in payload) {
          if (payload.simulive_test_run_end_time !== broadcast.simulive_test_run_end_time) {
            payload.test_simulive_processing_state = undefined;
          }
        }
        return { ...broadcast, ...payload };
      }
      return broadcast;
    });
  },
  filterSpeakerInBroadcasts(state: State, { broadcastIds, speakerId }: { broadcastIds: string[]; speakerId: string }) {
    state.broadcasts = state.broadcasts.map(broadcast => {
      if (broadcastIds?.includes(broadcast.id)) {
        return { ...broadcast, speakers: [...broadcast.speakers, speakerId] };
      }

      return {
        ...broadcast,
        speakers: broadcast.speakers.filter(speaker => speaker !== speakerId)
      };
    });
  },
  setNewAgendaItem(state: State, agendaItem: AgendaItem) {
    state.agendaItems = [...state.agendaItems, agendaItem];
  },
  setUpdatedAgendaItem(state: State, agendaItem: AgendaItem) {
    state.agendaItems = state.agendaItems.map(item => (item.id === agendaItem.id ? agendaItem : item));
  },
  setNewBroadcast(state: State, broadcast: Broadcast) {
    state.broadcasts = [...state.broadcasts, broadcast];
  },
  setBroadcastLoading(state: State, isBroadcastLoading: boolean) {
    state.isBroadcastLoading = isBroadcastLoading;
  },
  setAgendaItemsLoading(state: State, isAgendaItemsLoading: boolean) {
    state.isAgendaItemsLoading = isAgendaItemsLoading;
  },
  setAgendaTracksLoading(state: State, isAgendaTracksLoading: boolean) {
    state.isAgendaTracksLoading = isAgendaTracksLoading;
  },
  setUpdatedBroadcast(state: State, updatedBroadcast: Broadcast) {
    state.broadcasts = state.broadcasts.map(broadcast =>
      broadcast.id === updatedBroadcast.id ? updatedBroadcast : broadcast
    );
  },
  deleteBroadcast(state: State, broadcastId: string) {
    state.broadcasts = state.broadcasts.filter(broadcast => {
      return broadcast.id !== broadcastId;
    });
  },
  deleteAgendaItem(state: State, agendaItemId: number) {
    state.agendaItems = state.agendaItems.filter(agendaItem => {
      return agendaItem.id !== agendaItemId;
    });
  }
};
export default mutations;
